import { InvoiceService } from '@fitness-force/api';
import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormControl,
} from '@angular/forms';
import {
  AppErrors,
  NotFoundError,
} from '@fitness-force/errors';
import {AssignedToComponent} from '@fitness-force/common/assigned-to'
import {

  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';

import {
  BehaviorSubject,
  Observable,
  of,
} from 'rxjs';
import {  ShortNamePipe } from '@fitness-force/pipes/short-name'
import { ToastMessageService } from '@fitness-force/api';
import { ChangeSalesRep, Claim, Invoice, STAFFINTERFACE } from '@fitness-force/models';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { StaffStoreService } from 'libs/api/src/lib/staff/staff-store.service';
import { ConfirmationService } from 'primeng/api';
@Component({
  selector: 'change-bill-owner',
  templateUrl: './change-bill-owner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, SelectModule, FormsModule, ReactiveFormsModule, DialogModule, AvatarModule, ButtonModule, RippleModule, BlockUIModule, StyleClassModule, InputTextModule, PasswordModule, ShortNamePipe, AvatarModule, AssignedToComponent, ConfirmPopupModule, TranslateModule],
})
export class ChangeBillOwnerComponent implements OnInit {
  @Input('visible') changeBillOwnerModal: boolean = false;
  @Input('invoiceData') invoiceData: Invoice;
  @Input('filterstaff') staffIds$: Observable<number[]> = of([-1]);
  @Output() closeDialog = new EventEmitter();

  allClientData$ = new BehaviorSubject<any>({});
  currentStaff$ = new BehaviorSubject<any>({});
  selectedStaff$ = new BehaviorSubject<any>({});
  allStaffs$ = new BehaviorSubject<any>([]);
  updateBillOwnerForm: UntypedFormGroup = new UntypedFormGroup({});
  isClientRepresentative = new BehaviorSubject(true);
  claims: string[] = ['can_do_billing'];
  claim$: Observable<Claim[]> = new Observable();

  constructor(
    public translate: TranslateService,
    private fb: UntypedFormBuilder,
    private toastMessageService: ToastMessageService,
    private invoiceService: InvoiceService,
    private confirmationService: ConfirmationService,
    private staffStoreService: StaffStoreService
  ) {}

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.updateBillOwnerForm = this.fb.group({
      newRepresentative: ['', [Validators.required]],
    });
    this.isClientRepresentative.next(false);
    this.staffStoreService.getStaffById(this.invoiceData.sales_representative).subscribe((staff: STAFFINTERFACE) => {
      this.currentStaff$.next(staff);
      this.selectedStaff$.next(staff);
      this.NewRepresentative.setValue(staff.id);
    });
    // this.store.select(STAFF_STATE).subscribe((staff: any) => {
    //   this.allStaffs$.next(staff.staffListAll);
    //   const defaultStaff = staff.staffListAll.find(
    //     (s: any) => this.invoiceData.sales_representative == s.id
    //   );
    //   this.currentStaff$.next(defaultStaff);
    //   this.selectedStaff$.next(defaultStaff);
    //   this.NewRepresentative.setValue(defaultStaff);
    // });
  }

  confirm(event: Event) {
    let translation: any;
    this.translate.get(['BILL_OWNER_CHANGE.CHANGE_INFO','common.BUTTONS.BUTTON-TEXT-YES','common.BUTTONS.BUTTON-TEXT-NO'])
      .subscribe((translations) => {
        translation = translations;
      });
    this.confirmationService.confirm({
        target: event.target as EventTarget,
        key:'billowner',
        message: translation['BILL_OWNER_CHANGE.CHANGE_INFO'],
        icon: 'fa fa-exclamation-triangle',
        acceptLabel: translation['common.BUTTONS.BUTTON-TEXT-YES'],
        rejectLabel: translation['common.BUTTONS.BUTTON-TEXT-NO'],
        accept: () => {
          let changeSalesRep: ChangeSalesRep = {} as ChangeSalesRep;
          changeSalesRep.sales_rep_id = this.NewRepresentative.value.id;
          changeSalesRep.chnage_for_payments_linked_to_invoice= true;
          this.ChangeBillOwner(changeSalesRep);
        },
        reject: () => {
          let changeSalesRep: ChangeSalesRep = {} as ChangeSalesRep;
          changeSalesRep.sales_rep_id = this.NewRepresentative.value.id;
          changeSalesRep.chnage_for_payments_linked_to_invoice= false;
          this.ChangeBillOwner(changeSalesRep);;
        }
    });
}

  ChangeBillOwner(changeSalesRep: ChangeSalesRep) {
    this.invoiceService.ChangeSalesRep(this.invoiceData.tenant_id, this.invoiceData.client_id, this.invoiceData.id, changeSalesRep)
    .subscribe({
      next: () => {
        this.translate.get('BILL_OWNER_CHANGE.MSG.SUCCESS')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
        this.closeDialogEvent(true);
      },
      error: (error: AppErrors) => {
       if (error instanceof NotFoundError) {
          this.translate
            .get('common.errors.SERVER_SIDE.SOMETHING_WRONG')
            .subscribe((translation) => {
              this.toastMessageService.showErrorMessage(translation);
            });
        } else {
          if(error.errorCode == 'alreadyexist')
          {
            this.translate.get('BILL_OWNER_CHANGE.MSG.ALREADY_EXIST')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          }
          else{
            this.translate
            .get('common.errors.SERVER_SIDE.SOMETHING_WRONG')
            .subscribe((translation) => {
              this.toastMessageService.showErrorMessage(translation);
            });
          }
        }
      },
    });
  }

  get NewRepresentative(): UntypedFormControl {
    return this.updateBillOwnerForm.get(
      'newRepresentative'
    ) as UntypedFormControl;
  }

  selectStaff(staff: any) {
    this.selectedStaff$.next(staff);
    this.NewRepresentative.setValue(staff.id);
  }

  closeDialogEvent(updated = false) {
    this.changeBillOwnerModal = false;
    this.closeDialog.emit(updated ? { action: 'updated' } : updated);
  }
}